import React, { FC, PropsWithChildren, useState } from "react";

import { AnyObjectSchema } from "yup";

import FormPanelEdit from "./components/FormPanelEdit/FormPanelEdit";
import FormPanelRead from "./components/FormPanelRead/FormPanelRead";
import { StyledProfileFormPanel } from "./styled";
import { createFormSchema, DataSchemaRaw } from "./utils";

type ProfileFormPanelProps = {
    panelSchema: DataSchemaRaw[];
    title?: string;
    validationSchema?: AnyObjectSchema;
    dataTestId?: string;
    stringDivisor?: string;
    currentDetails?: MyBrokerApi.PersonalDetails | MyBrokerApi.AddressDetail;
    pendingDetails?: MyBrokerApi.PersonalDetails | MyBrokerApi.AddressDetail;
    isEditable?: boolean;
    readCustomSize?: boolean;
    isLoading?: boolean;
    onSubmit?: (values) => void;
};

export const ProfileFormPanel: FC<PropsWithChildren<ProfileFormPanelProps>> = ({
    title,
    children,
    validationSchema,
    panelSchema,
    dataTestId,
    stringDivisor,
    currentDetails,
    pendingDetails,
    readCustomSize = false,
    isEditable = false,
    isLoading = false,
    onSubmit,
}) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const mappedSchema = createFormSchema(panelSchema, currentDetails, pendingDetails);

    const handleCloseEdit = () => {
        setIsEditMode(false);
    };

    const handleOpenEdit = () => {
        setIsEditMode(true);
    };

    return (
        <StyledProfileFormPanel $isEditable={isEditable} data-testid={dataTestId}>
            {isEditMode ? (
                <FormPanelEdit
                    title={title}
                    validationSchema={validationSchema}
                    panelInfo={mappedSchema}
                    isLoading={isLoading}
                    onSubmit={onSubmit}
                    onClose={handleCloseEdit}
                >
                    {children}
                </FormPanelEdit>
            ) : (
                <FormPanelRead
                    title={title}
                    panelInfo={mappedSchema}
                    isEditable={isEditable}
                    stringDivisor={stringDivisor}
                    readCustomSize={readCustomSize}
                    onClickEdit={handleOpenEdit}
                >
                    {children}
                </FormPanelRead>
            )}
        </StyledProfileFormPanel>
    );
};

export default ProfileFormPanel;
